// extracted by mini-css-extract-plugin
export var banner = "_1x-0";
export var icon = "_1x-1";
export var message = "_1x-2";